import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import Typography from "@mui/material/Typography";

import BreadCrumb from "../../components/common/CustomBreadCrumbs";

import "./styles.scss";
import { GetBanks } from "../../utils/redux/Settings/SettingsSlice";
import { useNavigate, } from "react-router-dom";
import SuccessDisplay from "./Success/SuccessDisplay";
import { CurrentUser } from "../../utils/redux/Auth/AuthSlice";
import api, { walletApi } from "../../utils/redux/api";
import axiosServices from "../../services/axiosServices";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ChangeBankAccount = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [successView, setSuccessView] = useState(false);
  const [isFetchingAccount, setIsFetchingAccount] = useState(false);
  const [isSubmittingPin, setIsSubmittingPin] = useState(false);
  const [isSubmittingAccount, setIsSubmittingAccount] = useState(false);

  const dispatch = useDispatch();
  const data = useSelector((state) => state);
  const accountData = data?.settings?.verifiedBank?.responseModel;
  const user = data?.auth?.user?.responseModel;
  const BanksInNigeria = data?.settings?.banks?.data;
  const [grabAccountDetails, setGrabAccountDetails] = useState();

  const navigate = useNavigate();

  const val = BanksInNigeria?.find(
    (x) => x?.bankCode === accountData?.bankCode
  );

  useEffect(() => {
    dispatch(GetBanks());
    dispatch(CurrentUser());
    getAccountDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Function to fetch account details
  const fetchAccountDetails = async (
    bankCode,
    accountNumber,
    setFieldValue
  ) => {
    if (!bankCode || !accountNumber || accountNumber.length !== 10) {
      return;
    }

    setIsFetchingAccount(true);
    const body = {
      bankCode: bankCode,
      accountNumber: accountNumber,
      provider: "VFD",
    };

    try {
      const res = await walletApi.get(
        `Transaction/account-enquiry?provider=${body?.provider}&accountNumber=${body?.accountNumber}&bankCode=${body?.bankCode}`,
        body
      );

      if (res?.data?.status && res?.data?.data?.accountName) {
        setFieldValue("account_name", res.data.data.accountName, false);
        toast.success("Account details fetched successfully");
      } else {
        toast.error("Unable to fetch account details");
      }
    } catch (error) {
      console.log("error", error);
      toast.error("Error fetching account details");
    } finally {
      setIsFetchingAccount(false);
    }
  };

  const getAccountDetails = async () => {
    setIsLoading(true);
    const token = JSON.parse(localStorage.getItem("user_profile"))?.accessToken;

    try {
      const response = await api.get(
        "Superdealer/settlement-account",

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setGrabAccountDetails(response?.data?.data);
      // console.log("Account details:", response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <React.Fragment>
      <section>
        <nav id="quick-nav">
          <BreadCrumb
            breadcrumbs={[
              <Typography key="1" color="inherit">
                Settings / Add Bank Account
              </Typography>,
            ]}
          />
        </nav>
        {successView && (
          <SuccessDisplay
            buttonName={"Continue"}
            message={"Bank Account Added Successfully"}
          />
        )}

        {step1 && (
          <div className="change-pin-container">
            <div className="stepper-header">
              <p></p>
              <p className="steps">Step 1/2</p>
            </div>
            <Formik
              initialValues={{
                pin: "",
              }}
              validate={(values) => {
                const errors = {};
                if (!values.pin) {
                  errors.pin = "Password is required";
                }

                return errors;
              }}
              onSubmit={async (values, { setSubmitting }) => {
                setIsSubmittingPin(true);
                const token = JSON.parse(
                  localStorage.getItem("user_profile")
                )?.accessToken;
                const walletId = JSON.parse(
                  localStorage.getItem("user_profile")
                )?.walletId;

                const body = {
                  pin: values.pin,
                  walletId: walletId,
                };

                try {
                  const response = await axiosServices.post(
                    "securityservice/validate-pin",
                    body,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );
                  toast.success("PIN validated successfully");
                  setStep1(false);
                  setStep2(true);
                } catch (error) {
                  console.log(error);
                  toast.error("Invalid PIN. Please try again.");
                } finally {
                  setIsSubmittingPin(false);
                  setSubmitting(false);
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                isValid,
                dirty,
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="form_input_wrapper pin-input">
                    <label>
                      Input Pin <span>*</span>
                    </label>
                    <input
                      type="password"
                      name="pin"
                      onChange={handleChange}
                      value={values.pin}
                      placeholder="**********"
                      className={
                        errors.pin && touched.pin ? "input-error" : null
                      }
                    />
                    {errors.pin && touched.pin && (
                      <span className="error">{errors.pin}</span>
                    )}
                    <div className="notice">
                      <p>We'll confirm if your pin is valid.</p>
                    </div>
                  </div>

                  <div>
                    <button
                      type="submit"
                      className="login-btn"
                      disabled={isSubmittingPin}
                    >
                      {isSubmittingPin ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Validating...
                        </>
                      ) : (
                        "Continue"
                      )}
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        )}

        {step2 && (
          <div className="change-pin-container">
            <div className="stepper-header">
              <p
                className="go_back"
                onClick={() => {
                  setStep1(true);
                  setStep2(false);
                }}
              >
                <span>
                  <svg
                    width="8"
                    height="14"
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 1L1 7L7 13"
                      stroke="#25233A"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span>Back</span>
              </p>
              <p className="steps">Step 2/2</p>
            </div>
            <Formik
              initialValues={{
                bank: grabAccountDetails?.bankCode || user?.bankCode,
                account_number:
                  grabAccountDetails?.accountNumber || user?.accountNumber,
                account_name:
                  grabAccountDetails?.accountName || user?.accountName,
              }}
              validate={(values) => {
                const errors = {};
                if (!values.bank) {
                  errors.bank = "bank is required";
                }
                if (!values.account_name) {
                  errors.account_name = "account name is required";
                }
                if (!values.account_number) {
                  errors.account_number = "account number is required";
                }
                return errors;
              }}
              onSubmit={async (values, { setSubmitting }) => {
                setIsSubmittingAccount(true);
                // Find the selected bank from BanksInNigeria array
                const selectedBank = BanksInNigeria?.find(
                  (bank) => bank.bankCode === values.bank
                );

                if (!selectedBank) {
                  toast.error("Please select a valid bank");
                  setIsSubmittingAccount(false);
                  return;
                }

                const body = {
                  bankCode: values.bank,
                  bankName: selectedBank.bankName,
                  accountNumber: values.account_number,
                  accountName: values.account_name,
                };

                try {
                  const response = await api.post(
                    "Superdealer/settlement-account",
                    body
                  );
                  toast.success("Bank account updated successfully");
                  setSuccessView(true);
                  setStep2(false);
                } catch (error) {
                  console.error("Error:", error);
                  toast.error("Failed to add bank account. Please try again.");
                } finally {
                  setIsSubmittingAccount(false);
                  setSubmitting(false);
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                isValid,
                dirty,
                setFieldValue,
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="form_input_wrapper">
                    <label>
                      Select bank <span>*</span>
                    </label>
                    <select
                      name="bank"
                      onChange={(e) => {
                        handleChange(e);
                        if (values.account_number?.length === 10) {
                          fetchAccountDetails(
                            e.target.value,
                            values.account_number,
                            setFieldValue
                          );
                        }
                      }}
                      value={values.bank}
                      className={
                        errors.bank && touched.bank ? "input-error" : null
                      }
                    >
                      <>
                        <option value=""></option>
                        {BanksInNigeria?.map((item, index) => (
                          <option key={index} value={item.bankCode}>
                            {item.bankName}
                          </option>
                        ))}
                      </>
                    </select>
                    {errors.bank && touched.bank && (
                      <span className="error">{errors.bank}</span>
                    )}
                  </div>

                  <div className="form_input_wrapper">
                    <label>
                      Input account number <span>*</span>
                    </label>
                    <input
                      type="text"
                      name="account_number"
                      onChange={handleChange}
                      onBlur={(e) => {
                        handleBlur(e);
                        if (e.target.value.length === 10 && values.bank) {
                          fetchAccountDetails(
                            values.bank,
                            e.target.value,
                            setFieldValue
                          );
                        }
                      }}
                      value={values.account_number}
                      className={
                        errors.account_number && touched.account_number
                          ? "input-error"
                          : null
                      }
                      maxLength={10}
                    />
                    {errors.account_number && touched.account_number && (
                      <span className="error">{errors.account_number}</span>
                    )}
                    {isFetchingAccount && (
                      <div className="text-muted small mt-1">
                        Fetching account details...
                      </div>
                    )}
                  </div>

                  <div className="form_input_wrapper">
                    <label>
                      Account Name <span>*</span>
                    </label>
                    <input
                      type="text"
                      name="account_name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.account_name}
                      className={
                        errors.account_name && touched.account_name
                          ? "input-error"
                          : null
                      }
                      disabled
                    />
                    {errors.account_name && touched.account_name && (
                      <span className="error">{errors.account_name}</span>
                    )}
                  </div>

                  <div>
                    <button
                      disabled={
                        !values.account_name ||
                        isFetchingAccount ||
                        isSubmittingAccount
                      }
                      type="submit"
                      className="login-btn"
                    >
                      {isSubmittingAccount ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Saving...
                        </>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        )}
      </section>
    </React.Fragment>
  );
};

export default ChangeBankAccount;
